import axios from 'axios';

const base = `${process.env.REACT_APP_BACKEND_URL}/api/gps`;
export const gpsApi = {
  access: () => axios.get(`${base}/access`).then(r => r.data),
  status: course => axios.get(`${base}/courses/${encodeURIComponent(course)}`).then(r => r.data),
  send: (course, action, data) => axios.post(`${base}/courses/${encodeURIComponent(course)}/${action}`, data).then(r => r.data),
  settings: (course, data) => axios.put(`${base}/courses/${encodeURIComponent(course)}/settings`, data),
  disable: course => axios.delete(`${base}/courses/${encodeURIComponent(course)}/settings`),
  grant: (course, data) => axios.put(`${base}/courses/${encodeURIComponent(course)}/grants`, data),
};
export const gpsError = error => typeof error.response?.data?.detail === 'string' ? error.response.data.detail : error.message || 'GPS request failed.';